import React, { useState, useMemo, useEffect, useRef } from 'react';
import { Input, Checkbox, List, Row, Col } from 'antd';

const { Search } = Input;

const SearchableCheckableList = ({
    data = [],
    multiple = true,
    onItemsSelected = () => { },
    headerTitle = "Title",
    values = [],
}) => {

    const initialLoadRef = useRef(true);
    const [searchText, setSearchText] = useState('');
    const [checkedList, setCheckedList] = useState([]);
    const isMounted = useRef(false);
    const allIDs = useMemo(() => data.map((item) => item.id), [data]);

    // Set all checked for multiple or none for single
    // useEffect(() => {
    //   if (checkedList.length === 0) {
    //     if (multiple) {
    //       setCheckedList(allIDs);
    //     } else {
    //       setCheckedList([]);
    //     }
    //   }
    // }, [allIDs]);

    // Handle Search Input

    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value.toLowerCase());
    };

    // Filtered by search
    const filteredData = useMemo(() => {
        return data.filter((item) =>
            item.title.toLowerCase().includes(searchText)
        );
    }, [data, searchText]);

    const filteredIDs = useMemo(() => filteredData.map((item) => item.id), [filteredData]);

    const currentCheckedIDs = useMemo(
        () => filteredIDs.filter((id) => checkedList.includes(id)),
        [filteredIDs, checkedList]
    );

    const isAllSelected =
        multiple && filteredIDs.length > 0 && currentCheckedIDs.length === filteredIDs.length;

    const toggleSelectAll = (checked) => {
        if (!multiple) return;
        setCheckedList((prev) =>
            checked ? Array.from(new Set([...prev, ...filteredIDs])) : prev.filter((id) => !filteredIDs.includes(id))
        );
    };

    const handleCheck = (checked, id) => {
        console.log(`handleCheck: ${checked} for id: ${id}`);
        if (multiple) {
            setCheckedList((prev) =>
                checked ? [...prev, id] : prev.filter((item) => item !== id)
            );
        } else {
            setCheckedList(checked ? [id] : []);
        }
    };

    // Notify parent on change
    useEffect(() => {
        if (!isMounted.current) return;

        console.log('Checked items changed:', checkedList);
        const selectedData = data.filter((item) => checkedList.includes(item.id));
        console.log('checkedList: ', checkedList);
        console.log('data: ', data);
        console.log('multiple: ', multiple);
        console.log('onItemsSelected: ', onItemsSelected);

        // if(selectedData.length > 0) {
        //   onItemsSelected(selectedData);
        // }
        // Notify parent with selected data
        onItemsSelected(multiple ? selectedData : selectedData[0] || null);
    }, [checkedList, data, multiple, onItemsSelected]);

    useEffect(() => {
        setCheckedList((prev) => {
            if (initialLoadRef.current) {
                initialLoadRef.current = false;
                return values.length > 0 ? values : prev;
            }
            return prev;
        });
    }, [values]);

    return (
        <div style={{ width: '100%' }}>
            <Row justify="space-between" align="middle" style={{ marginBottom: 8 }}>
                <Col flex="auto">
                    <Search
                        placeholder="Search"
                        allowClear
                        onChange={handleSearchChange}
                        style={{ width: '100%' }}
                    />
                </Col>
                {multiple && (
                    <Col style={{ marginLeft: 16, whiteSpace: 'nowrap' }}>
                        {checkedList.length} of {data.length} selected
                    </Col>
                )}
            </Row>

            {multiple && (
                <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                    <Col flex="auto">
                        <Checkbox
                            checked={isAllSelected}
                            indeterminate={!isAllSelected && currentCheckedIDs.length > 0}
                            onChange={(e) => toggleSelectAll(e.target.checked)}
                        >
                            Select All
                        </Checkbox>
                    </Col>
                </Row>
            )}

            {/* Header */}
            <div
                style={{
                    backgroundColor: '#f0f0f0',
                    color: '#333',
                    height: '3em',
                    fontWeight: "semibold",
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    padding: '14px',
                    paddingLeft: "24px"
                }}
            >
                {headerTitle}
            </div>

            {/* Scrollable list */}
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <List
                    bordered={false}
                    dataSource={filteredData}
                    renderItem={(item) => (
                        <List.Item style={{ backgroundColor: "#fff", padding: '8px 16px', cursor: 'pointer' }}>
                            <Checkbox
                                checked={checkedList.includes(item.id)}
                                onChange={(e) => handleCheck(e.target.checked, item.id)}
                            >
                                {item.title}
                            </Checkbox>
                        </List.Item>
                    )}
                    locale={{ emptyText: 'No items found' }}
                />
            </div>
        </div>
    );
};

export default SearchableCheckableList;
